import React from 'react';
import PropTypes from 'prop-types';
import IconWithText from '../Icons/IconWithText';
import Button from '../Buttons/Button';

const ReportButton = ({ reported, ...rest }) => {
  let reportButton;
  if (reported === true) {
    reportButton = (
      <Button {...rest} faux>
        <IconWithText name="flag" size="m" fill="red">Reported</IconWithText>
      </Button>
    );
  } else {
    reportButton = (
      <Button {...rest} faux>
        <IconWithText name="flag" size="m" fill="black">Report this content</IconWithText>
      </Button>
    );
  }

  return reportButton;
};

ReportButton.propTypes = {
  reported: PropTypes.bool,
};

export default ReportButton;



// WEBPACK FOOTER //
// ./library/app/components/Global/Buttons/ReportButton.js